import { gql, useQuery } from '@apollo/client';

export const GET_QUESTIONNAIRES_DEVICE_INFO = gql`
  query getEmployeeDeviceInfoByQuestionnaireId($id: String!) {
    getEmployeeDeviceInfoByQuestionnaireId(id: $id) {
      os
      ip
      device
      browser
    }
  }
`;

export const useGetEmployeeDeviceInfoByQuestionnaireId = (id: string) => {
  const { data = {}, loading } = useQuery(GET_QUESTIONNAIRES_DEVICE_INFO, {
    variables: { id },
    skip: !id,
  });

  const deviceInfo = data?.getEmployeeDeviceInfoByQuestionnaireId

  return { deviceInfo, loading };
};
